
export const hasActiveFilters = (values: any = {}) => {
  let isActive = false;
  if (
    (typeof values.hashrate === 'number' && values.hashrate > 0)
    || (typeof values.search === 'string' && values.search !== '')
    || (typeof values.hashrate === 'number' && values.sharesInvalid > 0)
    || (typeof values.hashrate === 'number' && values.sharesStale > 0)
    || (values.status && values.status.length > 0)
  ) {
    isActive = true;
  }
  return isActive;
}
